
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[[...params]]",
      function () {
        return require("private-next-pages/home/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[[...params]]"])
      });
    }
  